module.exports = __webpack_public_path__ + "static/media/anc6ru.30b8ec9e.pdf";